import { AxiosError } from 'axios';
import { SWRConfiguration } from 'swr';

interface OptionsParamsSwrConfig {
  errorRetryCount?: number;
  suspense?: boolean;
  revalidateOnFocus?: boolean;
  revalidateOnMount?: boolean;
  revalidateIfStale?: boolean;
}

/**
 * Genera las opciones de configuración para SWR con valores por defecto.
 * Incluye una función shouldRetryOnError que evita reintentos en errores 404.
 *
 * @param config - Objeto de configuración opcional con las opciones de SWR
 * @returns Objeto de configuración de SWR con valores por defecto aplicados
 */
export const optionsParamsSwr = (config: OptionsParamsSwrConfig = {}): SWRConfiguration => {
  const {
    errorRetryCount = 0,
    suspense = false,
    revalidateOnFocus = false,
    revalidateOnMount = true,
    revalidateIfStale = false
  } = config;

  return {
    suspense,
    revalidateOnFocus,
    revalidateOnMount,
    revalidateIfStale,
    shouldRetryOnError: (error: AxiosError) => {
      return error?.response?.status !== 404;
    },
    errorRetryCount
  };
};
